import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザのパスワードをリセットする
 *
 * @param {Number} uid ユーザID
 * @returns {Response} レスポンスデータ
 */
export function resetUserPassword (uid) {
  return request.post(`/users/${uid}/password`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
